import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const ClassTeacherListJunior = () => {
  useEffect(() => {
    document.title =
      "Class Teacher List Junior -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics</li>
          <li>List of Class Teachers</li>
          <li> Class Teacher List (Junior)</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Class Teacher List (Junior)</h1>
            </div>
          </div>
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th> Sl No</th>
                    <th>Class</th>
                    <th>CLASS TEACHERS</th>
                  </tr>
                </thead>
                {/* <tbody>
                    <tr><td>1</td><td>V A</td><td>Ms Rajshree Rathore</td></tr>
                    <tr><td>2</td><td>V B</td><td>Ms Manita Casshyap</td></tr>
                    <tr><td>3</td><td>V C</td><td>Ms Santosh Kushwaha</td></tr>
                    <tr><td>4</td><td>V D</td><td>Ms Alka Goyal</td></tr>
                    <tr><td>5</td><td>V E</td><td>Ms Mamta Kaushik</td></tr>
                    <tr><td>6</td><td>V F</td><td>Ms Chandrika Mehta</td></tr>
                    <tr><td>7</td><td>IV A</td><td>Ms Reena</td></tr>
                    <tr><td>8</td><td>IV B</td><td>Ms Ashu Agarwal</td></tr>
                    <tr><td>9</td><td>IV C</td><td>Ms Noopur Chaturvedi</td></tr>
                    <tr><td>10</td><td>IV D</td><td>Ms Pramila Nair</td></tr>
                    <tr><td>11</td><td>IV E</td><td>Ms Manju Khattar</td></tr>
                    <tr><td>12</td><td>III A</td><td>Ms Sukhvinder Kaur</td></tr>
                    <tr><td>13</td><td>III B</td><td>Ms Pooja Khanna</td></tr>
                    <tr><td>14</td><td>III C</td><td>Ms Richee Jain</td></tr>
                    <tr><td>15</td><td>III D</td><td>Ms Kanchan Kumari</td></tr>
                    <tr><td>16</td><td>III E</td><td>Ms Preeti Tanotra</td></tr>
                    <tr><td>17</td><td>II A</td><td>Ms Sapna Pathania</td></tr>
                    <tr><td>18</td><td>II B</td><td>Ms Deeksha Bhatia</td></tr>
                    <tr><td>19</td><td>II C</td><td>Ms Sheeba Menon</td></tr>
                    <tr><td>20</td><td>II D</td><td>Ms Kiran Johar</td></tr>
                    <tr><td>21</td><td>II E</td><td>Ms Shefali Saini</td></tr>
                    <tr><td>22</td><td>I A</td><td>Ms Ishita Verma</td></tr>
                    <tr><td>23</td><td>I B</td><td>Ms Poonam</td></tr>
                    <tr><td>24</td><td>I C</td><td>Ms Babita</td></tr>
                    <tr><td>25</td><td>I D</td><td>Ms Sarita Tiwari</td></tr>
                    <tr><td>26</td><td>UKG A</td><td>Ms Vibhati Gauba</td></tr>
                    <tr><td>27</td><td>UKG B</td><td>Ms Riddhima Sharma</td></tr>
                    <tr><td>28</td><td>UKG C</td><td>Ms Rinku Singh</td></tr>
                   <tr class="colbg" align="center"> <td colspan="3">   Non Class Teachers</td> </tr>
                  
                   <tr>
                   <td> 29 </td> <td rowspan="2"> ACADEMIC </td> <td> Ms Ritu Walke </td> 
                  </tr> 
                  <tr>
                   <td> 30 </td> <td> Ms Monica Saroha </td> 
                  </tr>  
                  <tr>
                   <td> 31 </td> <td> MUSIC </td> <td>  Dr Parminder Singh </td> 
                  </tr> 
                  <tr>
                   <td> 32 </td> <td> DANCE </td> <td>Ms Charuta Verma </td> 
                  </tr> 
                  <tr>
                   <td> 33 </td> <td> LIBRARY </td> <td> Mr Gautam Das </td> 
                  </tr> 
                  <tr>
                   <td> 34 </td> <td rowspan="2"> DRAWING </td> <td> Ms Mamta Maurya </td> 
                  </tr> 
                  <tr>
                   <td> 35 </td>  <td> Ms Anu Mohan </td> 
                  </tr> 
                  <tr>
                   <td> 36 </td>   <td>Ms Yukti Madan </td> 
                  </tr> 
                  <tr>
                   <td> 37 </td> <td rowspan="2"> COMPUTER </td> <td> Ms Deepti Mor </td> 
                  </tr> 
                  <tr>
                   <td> 38 </td> <td> Ms Kulwinder Kaur </td> 
                  </tr> 
                  <tr>
                   <td> 39 </td> <td rowspan="4"> Games &amp; Sports (coaches) </td> <td> Mr. Lakshay Negi (FOOTBALL) </td> 
                  </tr> 
                  <tr>
                   <td> 40 </td> <td>  Mr Dinesh (BASKETBALL)</td> 
                  </tr> 
                  <tr>
                   <td> 41 </td> <td>  Mr Ajay (TAE-KWON-DO) </td> 
                  </tr> 
                  <tr>
                   <td> 42 </td> <td>  Mr Manjeet Singh (YOGA)</td> 
                  </tr>  
                    </tbody> */}
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>V A</td>
                    <td>Ms Santosh Kushwaha</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>V B</td>
                    <td>Ms. Ashu Agarwal</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>V C</td>
                    <td>Ms. Noopur Chaturvedi</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>V D</td>
                    <td>Ms. Pramila Nair</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>V E</td>
                    <td>Ms. Manju Khattar</td>
                  </tr>

                  <tr>
                    <td>6</td>
                    <td>IV A</td>
                    <td>Ms Reena</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>IV B</td>
                    <td>Ms. Manita Casshyap</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>IV C</td>
                    <td>Ms. Richee Jain</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>IV D</td>
                    <td>Ms. Alka Goyal</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>IV E</td>
                    <td>Ms. Chandrika Mehta</td>
                  </tr>

                  <tr>
                    <td>11</td>
                    <td>III A</td>
                    <td>Ms. Sukhwinder</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>III B</td>
                    <td>Ms Pooja Khanna</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>III C</td>
                    <td>Ms. Preeti Tanotra</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>III D</td>
                    <td>Ms. Babita</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>III E</td>
                    <td>Ms. Isha Arora</td>
                  </tr>

                  <tr>
                    <td>16</td>
                    <td>II A</td>
                    <td>Ms Sapna Pathania</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>II B</td>
                    <td>Ms. Diksha</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>II C</td>
                    <td>Ms Sheeba Menon</td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td>II D</td>
                    <td>Ms Kiran Johar</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>II E</td>
                    <td>Ms Shefali Saini</td>
                  </tr>

                  <tr>
                    <td>21</td>
                    <td>I A</td>
                    <td>Ms. Vibhati</td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td>I B</td>
                    <td>Ms Poonam</td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td>I C</td>
                    <td>Ms. Simran</td>
                  </tr>
                  <tr>
                    <td>24</td>
                    <td>I D</td>
                    <td>Ms Sarita Tiwari</td>
                  </tr>

                  <tr>
                    <td>25</td>
                    <td>UKG A</td>
                    <td>Ms. Rinku</td>
                  </tr>
                  <tr>
                    <td>26</td>
                    <td>UKG B</td>
                    <td>Ms Riddhima</td>
                  </tr>
                  <tr>
                    <td>27</td>
                    <td>Bal Vatika</td>
                    <td>Ms. Sonam</td>
                  </tr>
                  <tr>
                    <td>28</td>
                    <td>Bal Vatika</td>
                    <td>Ms. Tanya</td>
                  </tr>
                  <tr class="colbg" align="center">
                    {" "}
                    <td colspan="3"> Non Class Teachers</td>{" "}
                  </tr>

                  <tr>
                    <td>29</td>
                    <td rowspan="3">ACADEMIC</td>
                    <td>Ms Ritu Walke</td>
                  </tr>
                  <tr>
                    <td>30</td>
                    <td>Ms. Kanchan Jha</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td>Ms. Mamta Kaushik</td>
                  </tr>

                  <tr>
                    <td>32</td>
                    <td>MUSIC</td>
                    <td>Dr Parminder Singh</td>
                  </tr>

                  <tr>
                    <td>33</td>
                    <td>DANCE</td>
                    <td>Dance Teacher</td>
                  </tr>

                  <tr>
                    <td>34</td>
                    <td>LIBRARY</td>
                    <td>Mr Gautam Das</td>
                  </tr>

                  <tr>
                    <td>35</td>
                    <td>DRAWING</td>
                    <td>Ms Mamta</td>
                  </tr>

                  <tr>
                    <td>36</td>
                    <td>SPECIAL EDUCATOR</td>
                    <td>Ms Anu Mohan</td>
                  </tr>

                  <tr>
                    <td>37</td>
                    <td>COUNSELLOR</td>
                    <td>Ms Yukti</td>
                  </tr>

                  <tr>
                    <td>38</td>
                    <td rowspan="2">COMPUTER</td>
                    <td>Ms Deepti Mor</td>
                  </tr>
                  <tr>
                    <td>39</td>
                    <td>New Teacher</td>
                  </tr>

                  <tr>
                    <td>40</td>
                    <td rowspan="3">Games &amp; Sports Coaches</td>
                    <td>Mr. Lakshay (FOOTBALL)</td>
                  </tr>
                  <tr>
                    <td>41</td>
                    <td>Mr. Dinesh (BASKETBALL)</td>
                  </tr>
                  <tr>
                    <td>42</td>
                    <td>Ms. Kajal (YOGA)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassTeacherListJunior;
